import AppClientCredential from "./Credential";

class ContactCredential extends AppClientCredential
{
    constructor() {
        super('contact');
    }
}

export default ContactCredential;